<product-row [product]="product"></product-row>
